/** Autocomplete domain query segments */
export const AutocompleteQueryKeys = {
  search: (path: string, payload: unknown) => [{ path, payload }] as const,
  resource: (resourceName: string, payload: unknown) => [`autocomplete/${resourceName}`, payload] as const,
};
